import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import OTPPage from './pages/OTPPage';
import NotFound from './pages/NotFound';
import RegistrationPage from './pages/RegistrationPage/RegistrationPage';
import QRCodePage from './pages/QRCodePage/QRCodePage';
import ActivityPage from './pages/ActivityPage';
import NoticeListPage from './pages/NoticeListPage';
import NoticeDetailPage from './pages/NoticeDetailPage';
import SuccessPage from './pages/SuccessPage';
import LoginPage from './pages/LoginPage/LoginPage';
import MemberPage from './pages/MemberPage';
import { FAN_MEMBER_LIST } from './config/fanMembersConfig';
import { useTheme } from './hooks/useTheme';
import axios from './api/axios';
import Cookies from 'js-cookie';

// Admin Pages
import AdminLogin from './pages/AdminPage/AdminLogin';
import AdminLayout from './pages/AdminPage/AdminLayout';
import AdminHomePage from './pages/AdminPage/AdminHomePage';
import FormManagement from './pages/AdminPage/FormManagement';
import RegistrationSearch from './pages/AdminPage/RegistrationSearch';
import AdminQRScannerPage from './pages/AdminPage/QRScannerPage';
import ActivityManagement from './pages/AdminPage/ActivityManagement';
import ProtectedRoute from './components/ProtectedRoute';
import FanMemberProtectedRoute from './components/FanMemberProtectedRoute';

// Set axios Authorization header from cookie on app startup
const token = Cookies.get('adminToken');
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

const App = () => {
  useTheme();

  return (
    <Router>
      <Routes>
        {/* Branded fan-member routes (Jemari, Menaone, …) */}
        {FAN_MEMBER_LIST.map(({ slug }) => (
          <React.Fragment key={slug}>
            <Route path={`/${slug}`} element={<RegistrationPage fixedFanSlug={slug} />} />
            <Route path={`/${slug}/login`} element={<LoginPage fixedFanSlug={slug} />} />
            <Route path={`/${slug}/verify`} element={<OTPPage fixedFanSlug={slug} />} />
            <Route path={`/${slug}/qr-code`} element={<QRCodePage fixedFanSlug={slug} />} />
            <Route path={`/${slug}/success`} element={<SuccessPage fixedFanSlug={slug} />} />
            <Route
              path={`/${slug}/member`}
              element={
                <FanMemberProtectedRoute fanSlug={slug}>
                  <MemberPage fixedFanSlug={slug} />
                </FanMemberProtectedRoute>
              }
            />
          </React.Fragment>
        ))}

        <Route path="/:activityType/:id" element={<ActivityPage />} />
        <Route path="/:activityType/:id/register" element={<RegistrationPage />} />
        <Route path="/:activityType/:id/login" element={<LoginPage />} />
        <Route path="/:activityType/:id/verify" element={<OTPPage />} />
        <Route path="/:activityType/:id/qr-code" element={<QRCodePage />} />
        <Route path="/:activityType/:id/success" element={<SuccessPage />} />
        <Route path="/:activityType/:activityId/member" element={<MemberPage />} />

        <Route path="/notices" element={<NoticeListPage />} />
        <Route path="/notices/:id" element={<NoticeDetailPage />} />

        {/* Admin Routes */}
        <Route path="/admin/:activityId/login" element={<AdminLogin />} />
        <Route path="/admin/activities" element={<ActivityManagement />} />
        <Route
          path="/admin/:activityId"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<AdminHomePage />} />
          <Route path="forms" element={<FormManagement />} />
          <Route path="registrations" element={<RegistrationSearch />} />
          <Route path="scanner" element={<AdminQRScannerPage />} />
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
      {/* <Footer /> */}
    </Router>
  );
};

export default App;
